import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Manifesto } from "@/components/Manifesto";
import { BrandBento } from "@/components/BrandBento";
import { Heritage } from "@/components/Heritage";
import { News } from "@/components/News";
import { Appointment } from "@/components/Appointment";
import { Contact } from "@/components/Contact";
import { WelcomeNote } from "@/components/WelcomeNote";
import { scrollToTarget } from "@/lib/scroll";

export default function Home() {
  const { hash, state } = useLocation();

  useEffect(() => {
    if (!hash) return undefined;
    const t = setTimeout(() => scrollToTarget(hash, { immediate: false }), 250);
    return () => clearTimeout(t);
  }, [hash]);

  return (
    <main data-testid="home-page">
      <Hero />
      <Marquee />
      <Manifesto />
      <BrandBento />
      <Heritage />
      <News />
      <Appointment preselect={state?.brand} />
      <Contact />
      <WelcomeNote />
    </main>
  );
}
